import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const accountSearchResultLicensedUsersSlice = getCachedTableDataSlice<
    Record<string, number>,
    AccountSearchCriteria,
    AccountSortField,
    AccountSearchFiltering
>('accountSearchResultLicensedUsers');

export const accountSearchResultLicensedUsersActions = accountSearchResultLicensedUsersSlice.actions;

const accountSearchResultLicensedUsersCacheSelector: CachedTableCacheSelector<Record<string, number>>
    = state => state.accountSearchResult.licensedUsers.cache;
export const accountSearchResultLicensedUsersDataSelector: CachedTableDataSelector<Record<string, number>>
    = state => state.accountSearchResult.licensedUsers;
export const accountSearchResultLicensedUsersResultSelector = getCachedTableResultSelector(
    accountSearchResultLicensedUsersCacheSelector,
    accountSearchResultStateSelector,
);
